
import { IModel } from '../base/annotation';
import { Metamodel } from '../base/model';
import { TaggableNamed } from '../base/taggable-named';
import { shellStringResources } from '../../Resources/ShellStringResources';
import { NamedValidations } from '../base/named-validations';
import { ValidationConstants } from '../../shared/validation-constants';
import { format } from '../../shared/utils/string.util';
import { Folder } from '../folder/folder';
import { Owned } from '../base/named';

@Metamodel.model({
    name: 'airflowEntity',
    display: [shellStringResources.AirflowEntity, shellStringResources.AirflowEntities],
    reusable: true,
    abstract: false,
    referable: true,
    constraints: {
        name: {
            required: true,
            patterns: [
                {
                    message: format(shellStringResources.Validator_NamePattern_StartEnd_Alphanumeric, shellStringResources.AirflowEntity),
                    regex: ValidationConstants.startEndWithAlphaNumericValidator
                },
                {
                    message: format(shellStringResources.Validator_NameMaxLength, shellStringResources.AirflowEntity, ValidationConstants.maxEntityNameLength.toString()),
                    regex: ValidationConstants.factoryEntityNameLengthValidator
                },
                {
                    message: format(shellStringResources.Validator_NameMinLength, shellStringResources.AirflowEntity, ValidationConstants.minDatasetNameLength.toString()),
                    regex: ValidationConstants.datasetNameMinLengthValidator
                },
                {
                    message: format(shellStringResources.Validator_NamePattern_All_AlphanumericUnderscore, shellStringResources.AirflowEntity),
                    regex: ValidationConstants.alphanumericUnderscore
                }
            ],
            uniqueModelName: true,
            validator: NamedValidations.KeyWordsValidator
        },
        subType:{
            required: true,
            patterns: [
                {
                    message: shellStringResources.Validator_AirflowEntity_ValidSubtypeRequired,
                    regex: ValidationConstants.airflowEntitySubTypeValidator
                }
            ]
        }
    }
})
export class AirflowEntity extends TaggableNamed {

    public static readonly MODEL: IModel;

    public subType: string = '';
    public fileContent: string = '';
    public scope: string = '';
    public folder: Folder = Owned.create(Folder.MODEL, this);

    constructor(name?: string, description?: string) {
        super(name, description);
    }
}
